import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useParams,
} from "react-router-dom";
import "@/App.css";
import {
  LanguageProvider,
  SUPPORTED_LANGS,
  DEFAULT_LANG,
} from "@/i18n/LanguageProvider";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";

function LangLayout() {
  const { lang } = useParams();
  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }
  return (
    <LanguageProvider>
      <div className="min-h-screen flex flex-col bg-white">
        <Header />
        <div className="flex-1">
          <Outlet />
        </div>
        <Footer />
        <CookieBanner />
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={<Navigate to={`/${DEFAULT_LANG}`} replace />}
        />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/:lang" element={<LangLayout />}>
          <Route index element={<Home />} />
          <Route path="privacy-policy" element={<LegalPage pageKey="privacy" />} />
          <Route path="cookie-policy" element={<LegalPage pageKey="cookies" />} />
          <Route path="terms" element={<LegalPage pageKey="terms" />} />
        </Route>
        <Route
          path="*"
          element={<Navigate to={`/${DEFAULT_LANG}`} replace />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
